import * as React from 'react'

import { type TMask, cn, mask } from '@/lib/client'
import type { FormEvent } from 'react'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const onKeyUp = (e: FormEvent<HTMLInputElement>) => {
  if (e.currentTarget.name === 'document') {
    const type = e.currentTarget.getAttribute('data-type')
    e.currentTarget.maxLength = type === 'company' ? 18 : 14
    const cleanValue = e.currentTarget.value.replace(/\D/g, '')
    const maskType = cleanValue.length <= 11 ? 'cpf' : 'cnpj'
    const value = mask(e.currentTarget.value, maskType)
    e.currentTarget.value = value
  }

  if (e.currentTarget.name === 'zipcode') {
    e.currentTarget.maxLength = 10
    const value = mask(e.currentTarget.value, 'cep')
    e.currentTarget.value = value
  }

  if (e.currentTarget.name === 'card_number') {
    e.currentTarget.maxLength = 19
    const value = mask(e.currentTarget.value, 'card_number')
    e.currentTarget.value = value
  }

  if (e.currentTarget.name === 'card_name') {
    const value = mask(e.currentTarget.value, 'card_name')
    e.currentTarget.value = value
  }

  if (e.currentTarget.name === 'card_date') {
    e.currentTarget.maxLength = 5
    const value = mask(e.currentTarget.value, 'card_date')
    e.currentTarget.value = value
  }

  if (e.currentTarget.name === 'card_cvv') {
    e.currentTarget.maxLength = 4
  }

  // if (isDateCreditCard) {
  //   e.currentTarget.maxLength = 5
  //   const value = creditCardDateMask(e.currentTarget.value)
  //   e.currentTarget.value = value
  // }

  if (e.currentTarget.name === 'phone') {
    e.currentTarget.maxLength = 15
    const value = mask(e.currentTarget.value, 'phone')
    e.currentTarget.value = value
  }

  // if (isDate) {
  //   e.currentTarget.maxLength = 10
  //   const value = dateMask(e.currentTarget.value)
  //   e.currentTarget.value = value
  // }

  // if (isNumber) {
  //   e.currentTarget.maxLength = 5
  //   const value = numberMask(e.currentTarget.value)
  //   e.currentTarget.value = value
  // }

  // if (e.currentTarget.name === 'email') {
  //   const value = e.currentTarget.value.toLocaleLowerCase()
  //   e.currentTarget.value = value
  // }
}

const Input = React.forwardRef<
  HTMLInputElement,
  InputProps & { invalid?: boolean; left?: JSX.Element; right?: JSX.Element }
>(({ className, type, left, right, invalid, ...props }, ref) => {
  if (props.defaultValue) {
    const name = props.name as TMask
    if (name) {
      const value = mask(String(props.defaultValue), name)
      props.defaultValue = value
    }
  }

  const input = (
    <input
      type={type}
      className={cn(
        `flex h-10 w-full border border-input ring-offset-background rounded-sm px-2 py-2 text-xs 
        file:border-0 bg-background file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground
        focus:outline-none focus-visible:outline-none
        disabled:cursor-not-allowed disabled:opacity-50`,
        left || right
          ? 'h-9 border-0'
          : 'focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500',
        invalid &&
          'border-rose-500 text-rose-600 focus:border-rose-500 focus:ring-rose-500',
        className,
      )}
      onKeyUp={onKeyUp}
      ref={ref}
      {...props}
    />
  )

  if (left || right)
    return (
      <div
        className={cn(
          'flex h-10 items-center rounded-sm border border-input text-sm bg-white group focus-within:border-orange-500 focus-within:ring-1 focus-within:ring-orange-500',
          left && 'pl-3',
          right && 'pr-3',
          invalid &&
            'border-rose-500 text-rose-600 focus:border-rose-500 focus:ring-rose-500',
          className,
        )}
      >
        {left}
        {input}
        {right}
      </div>
    )

  return input
})
Input.displayName = 'Input'

export { Input }
